import { TStageGroupIdentifier } from '../interfaces/stage-mapping.types'

export const getBgColorByIdentifier = (identifier: TStageGroupIdentifier) => {
   switch (identifier) {
      case 'ff-under-contract':
         return '#9F7BFF'
      case 'ff-active-client':
         return '#9F7BFF'
      case 'ff-closed-client':
         return '#9F7BFF'
      case 'ff-appointment-set':
         return '#00552A'
      case 'ff-appointment-missed':
         return '#FF4B4B'
      case 'ff-do-not-contact':
         return '#FF4B4B'
      case 'ff-has-agent':
         return '#FF4B4B'
      case 'ff-other-stop':
         return '#FF4B4B'
      default:
         return '#9F7BFF'
   }
}

// Convert hex color to rgba with 50% opacity
export const hexToRgba = (hex: string, opacity: number) => {
   const r = parseInt(hex.slice(1, 3), 16)
   const g = parseInt(hex.slice(3, 5), 16)
   const b = parseInt(hex.slice(5, 7), 16)
   return `rgba(${r}, ${g}, ${b}, ${opacity})`
}
